// components/journal/MetricInput.tsx
import React from 'react';
import { LucideIcon } from 'lucide-react';

interface MetricInputProps {
  icon: LucideIcon;
  label: string;
  value: number;
  onChange: (value: number) => void;
  readonly?: boolean;
}

export function MetricInput({
  icon: Icon,
  label,
  value,
  onChange,
  readonly
}: MetricInputProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center space-x-2">
        <Icon className="w-5 h-5 text-gray-600 dark:text-gray-400" />
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
        </label>
      </div>
      <div className="flex space-x-2">
        {[1, 2, 3, 4, 5].map((number) => (
          <button
            key={number}
            onClick={() => !readonly && onChange(number)}
            disabled={readonly}
            className={`w-10 h-10 rounded-full flex items-center justify-center ${
              value === number
                ? 'bg-blue-500 dark:bg-blue-600 text-white'
                : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'
            } ${readonly ? 'cursor-default' : 'cursor-pointer'}`}
          >
            {number}
          </button>
        ))}
      </div>
    </div>
  );
}
